import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleGrid from './components/ArticleGrid';
import ReviewSection from './components/ReviewSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleGrid />
        <ReviewSection />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '911爆料网',
            alternateName: '911黑料网',
            url: 'https://4xhyp.com/',
            description: '吃瓜黑料第一站 - 每日实时更新网红翻车、明星八卦、反差视频等热门大瓜',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://4xhyp.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </>
  );
}
